// src/data/blog/index.ts
// Registry of all blog posts. To add a post: create src/data/blog/posts/<slug>.ts and add it below.
import { BlogPost } from '../../types/blogTypes';
import whyATeamOfSpecialistsBeatsOneChatbot from './posts/why-a-team-of-specialists-beats-one-chatbot';
import whoDoYouTalkToAt2am from './posts/who-do-you-talk-to-at-2am';
import negotiateYourSalaryBeforeYouWalkIn from './posts/negotiate-your-salary-before-you-walk-in';
import mockInterviewInYourPocket from './posts/mock-interview-in-your-pocket';
import honestFeedbackWhenEveryoneSaysYes from './posts/honest-feedback-when-everyone-says-yes';
import dinnerFromWhateverIsInYourFridge from './posts/dinner-from-whatever-is-in-your-fridge';
import talkDontTypeVoiceMode from './posts/talk-dont-type-voice-mode';
import stoicToolsForAStressfulWeek from './posts/stoic-tools-for-a-stressful-week';
import stuckOnChapterThree from './posts/stuck-on-chapter-three';
import newCityZeroFriends from './posts/new-city-zero-friends';
import buildYourOwnAiCompanion from './posts/build-your-own-ai-companion';
import whatHappensToYourConversations from './posts/what-happens-to-your-conversations';
import stopRereadingYourNotes from './posts/stop-rereading-your-notes';
import studySmarterFinalsWeek from './posts/study-smarter-finals-week';
import learnEnglishFasterSpeakFromDayOne from './posts/learn-english-faster-speak-from-day-one';
import learnALanguageWithoutFeelingEmbarrassed from './posts/learn-a-language-without-feeling-embarrassed';
import englishMistakesFluentSpeakersMake from './posts/english-mistakes-fluent-speakers-make';
import turnYourToDoListIntoAPlan from './posts/turn-your-to-do-list-into-a-plan';
import the10MinuteSundayReset from './posts/the-10-minute-sunday-reset';
import whatToWearTomorrow from './posts/what-to-wear-tomorrow';
import dressingForInterviewDateWedding from './posts/dressing-for-interview-date-wedding';
import stayInTheLoopWithoutDoomscrolling from './posts/stay-in-the-loop-without-doomscrolling';
import genZSlangParentsGuide from './posts/gen-z-slang-parents-guide';

const ALL_POSTS: BlogPost[] = [
  whyATeamOfSpecialistsBeatsOneChatbot,
  whoDoYouTalkToAt2am,
  negotiateYourSalaryBeforeYouWalkIn,
  mockInterviewInYourPocket,
  honestFeedbackWhenEveryoneSaysYes,
  dinnerFromWhateverIsInYourFridge,
  talkDontTypeVoiceMode,
  stoicToolsForAStressfulWeek,
  stuckOnChapterThree,
  newCityZeroFriends,
  buildYourOwnAiCompanion,
  whatHappensToYourConversations,
  stopRereadingYourNotes,
  studySmarterFinalsWeek,
  learnEnglishFasterSpeakFromDayOne,
  learnALanguageWithoutFeelingEmbarrassed,
  englishMistakesFluentSpeakersMake,
  turnYourToDoListIntoAPlan,
  the10MinuteSundayReset,
  whatToWearTomorrow,
  dressingForInterviewDateWedding,
  stayInTheLoopWithoutDoomscrolling,
  genZSlangParentsGuide,
];

/** Newest first. */
export const BLOG_POSTS: BlogPost[] = [...ALL_POSTS].sort((a, b) =>
  a.publishedAt < b.publishedAt ? 1 : -1,
);

export const getPostBySlug = (slug: string): BlogPost | undefined =>
  BLOG_POSTS.find((post) => post.slug === slug);

const RELATED_COUNT = 3;
const INTERNAL_LINK_PATTERN = /\]\(\/blog\/([a-z0-9-]+)\/\)/g;

/** Posts linked from the body first, then same category, then newest. Never includes the post itself. */
export const getRelatedPosts = (post: BlogPost): BlogPost[] => {
  const linkedSlugs = Array.from(post.body.matchAll(INTERNAL_LINK_PATTERN)).map((match) => match[1]);
  const candidates = [
    ...linkedSlugs.map(getPostBySlug),
    ...BLOG_POSTS.filter((other) => other.category === post.category),
    ...BLOG_POSTS,
  ].filter((other): other is BlogPost => Boolean(other) && other?.slug !== post.slug);
  return Array.from(new Map(candidates.map((other) => [other.slug, other])).values()).slice(
    0,
    RELATED_COUNT,
  );
};
